import { hasRequiredFields } from '@move-frontend/utils';
import { IChangePasswordFormData } from '../../../model/IChangePasswordFormData';
import { useChangePasswordFormContext } from './useChangePasswordFormContext';

export function useChangePasswordHasRequiredFields() {
	const { watch } = useChangePasswordFormContext();
	const values: Partial<IChangePasswordFormData> = watch();

	return hasRequiredFields(values, [
		'currentPassword',
		'password',
		'confirmPassword',
	]);
}
